export default __webpack_public_path__ + "static/media/featured.68cfb969.png";